import React, { useState } from 'react';

import { Col, Empty, Row, Space } from 'antd';

import {
  FormAddButton,
  FormCancelButton,
  FormSaveButton,
} from 'common/components';

import { IXOneHierarchyTree } from 'pages/product-full-view/components/product-hierarchy/IXOneHierarchyTree';
import { IXOneHierarchyAddModal } from '../ixone-credit-card/IXOneHierarchy';

import { useGetProductFullView } from 'hooks';
import { useIXOneCapture } from '../ixone-credit-card/IXOneContext';
import { useHierarchyAppliedProduct } from './hooks';

import { getAllIXOneRows, getNewRowData, mappingHierarchies } from './utils';
import { toArray } from 'utils/array';

import * as creditCardServices from 'services/creditCardEula';

export const IXOneHierarchyModal = (props) => {
  const { productId, hierarchies, offModalListHierarchy } = props;
  const [visibleAddHierarchy, setVisibleAddHierarchy] = useState(false);

  const { selectedHierarchies, ixoneGridApi } = useIXOneCapture();

  const [tempSelectedHierarchy, setTempSelectedHierarchy] = useState(
    selectedHierarchies?.[productId]?.selectedHierarchy
  );

  const { productFull } = useGetProductFullView({ productId });

  const { applySelectedHierarchyForProduct } = useHierarchyAppliedProduct();

  const isEmptyHierarchy = hierarchies?.length === 0;

  const handleSelectHierarchy = () => {
    const allRowData = getAllIXOneRows(ixoneGridApi);

    applySelectedHierarchyForProduct({
      allRowData,
      selectedHierarchy: tempSelectedHierarchy,
      productId,
    });

    offModalListHierarchy();
  };

  const handleAddNewHierarchySuccess = async () => {
    const allRowData = getAllIXOneRows(ixoneGridApi);

    const response = await creditCardServices.getProductsForCapture({
      productIds: toArray(productId),
    });
    if (response?.isSuccess) {
      const { verifiedProducts } = response?.data;
      const hierarchies = verifiedProducts?.[0]?.hierarchies;

      const newRowData = getNewRowData({
        allRowData,
        productId,
        newHierarchies: hierarchies,
      });

      ixoneGridApi.api.applyTransaction({
        update: newRowData,
      });
    }
  };

  return (
    <div>
      <div
        style={{ minHeight: 440, maxHeight: 500 }}
        className='ixone-section--hierarchy-tree scroller'
      >
        {isEmptyHierarchy ? (
          <Empty />
        ) : (
          <IXOneHierarchyTree /* I'll refactor this component later */
            hierarchyData={mappingHierarchies(hierarchies)}
            publishPackageList={[]}
            isLoading={false}
            isInCheckPublishErrorMode={false}
            selectedHierarchy={tempSelectedHierarchy}
            onSelectHierarchy={(hierarchyValue) =>
              setTempSelectedHierarchy(hierarchyValue)
            }
          />
        )}
      </div>
      <IXOneHierarchyModalFooter
        onAddNewHierarchy={() => setVisibleAddHierarchy(true)}
        onCancel={offModalListHierarchy}
        onSubmit={handleSelectHierarchy}
      />
      {visibleAddHierarchy && (
        <IXOneHierarchyAddModal
          productId={productId}
          currentProduct={productFull}
          visible={visibleAddHierarchy}
          setVisible={setVisibleAddHierarchy}
          onCallApiSuccess={handleAddNewHierarchySuccess}
        />
      )}
    </div>
  );
};

export const IXOneHierarchyModalFooter = ({
  onAddNewHierarchy,
  onCancel,
  onSubmit,
  isSubmitting = false,
}) => {
  return (
    <Row align='middle' justify='space-between' style={{ paddingTop: 12 }}>
      <Col>
        <FormAddButton text='Add Hierarchy' onClick={onAddNewHierarchy} />
      </Col>
      <Col>
        <Space>
          <FormCancelButton onClick={onCancel} disabled={isSubmitting} />
          <FormSaveButton
            text='Submit'
            onClick={onSubmit}
            loading={isSubmitting}
          />
        </Space>
      </Col>
    </Row>
  );
};
